import _regenerator from "/root/workspace/frontend_teacher-web-xiyou_WfnQ/teacher-web/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/frontend_teacher-web-xiyou_WfnQ/teacher-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { logout as _logout } from '@/api/login';
import NavMenu from '@/layout/components/NavMenu/index.vue';
export default {
  name: 'Header',
  components: {
    NavMenu: NavMenu
  },
  data: function data() {
    return {
      hiddenGlobalNav: false,
      head: null,
      name: '游客',
      schoolName: '游客',
      navShow: false
    };
  },
  computed: {
    userInfo: function userInfo() {
      return this.$store.state.userInfo;
    }
  },
  created: function created() {
    this.hiddenGlobalNav = sessionStorage.getItem('hiddenGlobalNav');
    this.getInfo();
  },
  methods: {
    // 显示/隐藏弹框
    subNavShow: function subNavShow() {
      this.navShow = !this.navShow;
    },
    // 获取信息
    getInfo: function getInfo() {
      this.head = sessionStorage.getItem('teacherHead');
    },
    // 账号设置
    set: function set() {
      this.$router.push({
        name: 'manage'
      });
    },
    // 去首页
    goHome: function goHome() {
      this.$router.push({
        name: 'home'
      });
    },
    // 退出登录
    logout: function logout() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return _logout();
            case 1:
              _this.$store.commit('clearInclude');
              _this.$store.commit('setUserInfo', {});
              sessionStorage.clear();
              _this.common.globalData.gradeTypeId = null;
              _this.common.globalData.provinceId = null;
              _this.common.globalData.cityId = null;
              _context.n = 2;
              return _this.$router.push({
                name: 'login'
              });
            case 2:
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[0, 3]]);
      }))();
    }
  }
};